import { AbstractJsonApiService } from '@ipensii/shared/data-access-shared';

export class UrlShortenerService extends AbstractJsonApiService<unknown> {
  constructor() {
    super('url');
  }

  redirectFormShortSmsUrlToActualUrl({ urlShortenerUuid }: { urlShortenerUuid: string }) {
    return this.http.get(`${this.url}/${urlShortenerUuid}`, { observe: 'response' ,responseType: 'text'})
  }
}
